import { ICintorinConfig } from "./common/interfaces";
import { getLocalizedText } from "./common/translations";
import { dismissModal, openModal } from "./common/utilities";
import { attachCvPhotoEventHandlers } from "./fotky";
import { addAuthorization, toggleAuthorizedElementsVisibility } from "./iam";

// deklarujem ako vyzera CintorinConfig objekt bez toho aby sa includol do kniznice
declare const CintorinConfig: ICintorinConfig;

export function attachMemoryEventHandlers() {
    document.getElementById("addMemoryButton")?.addEventListener("click", openCreateMemoryModal);
    document.getElementById("memoryText")?.addEventListener("input", validateMemoryText);
    document.getElementById("memoryFormButton")?.addEventListener("click", submitMemoryForm);
    document.querySelector("#editMemoryModal .btn-close")?.addEventListener("click", function () { dismissModal("#editMemoryModal"); });
}

export function attachCvEventHandlers() {
    document.getElementById("addCvButton")?.addEventListener("click", openNewCvForm);
    document.getElementById("editCvLink")?.addEventListener("click", openEditCvForm);
    document.getElementById("deleteCvLink")?.addEventListener("click", deleteCv);
    document.getElementById("reportCvLink")?.addEventListener("click", reportCv);
    document.getElementById("cvUndoChangesButton")?.addEventListener("click", undoCvChanges);
    document.getElementById("cvSaveChangesButton")?.addEventListener("click", saveCvChanges);
    document.getElementById("editedCv")?.addEventListener("paste", filterPastedContent);
    document.getElementById("editedCv")?.addEventListener("drop", filterDroppedContent);
    document.getElementById("editedCv")?.addEventListener("input", validateCvText);

    attachCvPhotoEventHandlers();
}

export function attachMemoryActionsEventHandlers() {
    document.querySelectorAll(".memento span[data-action=edit]").forEach(e => e.addEventListener("click", openEditMemoryModal));
    document.querySelectorAll(".memento span[data-action=delete]").forEach(e => e.addEventListener("click", deleteMemory));
    document.querySelectorAll(".memento span[data-action=report]").forEach(e => e.addEventListener("click", reportMemory));
}

function openCreateMemoryModal() {
    (document.getElementById("memoryModalAction") as HTMLInputElement).value = "create";
    (document.getElementById("editedMemoryId") as HTMLInputElement).value = "";
    (document.getElementById("newMemoryTitle") as HTMLInputElement).style.display = "";
    (document.getElementById("editMemoryTitle") as HTMLInputElement).style.display = "none";
    (document.getElementById("memoryText") as HTMLTextAreaElement).value = "";
    openModal("#editMemoryModal");
}

function openEditMemoryModal() {
    let memoryId = +this.parentElement.parentElement.parentElement.getAttribute("data-memory-id");
    let messageText = this.parentElement.parentElement.parentElement.querySelector(".memento-text").innerText;
    (document.getElementById("memoryModalAction") as HTMLInputElement).value = "edit";
    (document.getElementById("editedMemoryId") as HTMLInputElement).value = memoryId+"";
    (document.getElementById("newMemoryTitle") as HTMLInputElement).style.display = "none";
    (document.getElementById("editMemoryTitle") as HTMLInputElement).style.display = "";
    (document.getElementById("memoryText") as HTMLTextAreaElement).value = messageText;
    (document.getElementById("memoryFormButton") as HTMLButtonElement).disabled = false;
    openModal("#editMemoryModal");
}

function validateMemoryText() {
    let text = (document.getElementById("memoryText") as HTMLTextAreaElement).value.trim();
    if (text?.length > 0) {
        (document.getElementById("memoryFormButton") as HTMLButtonElement).disabled = false;
    } else {
        (document.getElementById("memoryFormButton") as HTMLButtonElement).disabled = true;
    }
}

function submitMemoryForm() {
    let action = (document.getElementById("memoryModalAction") as HTMLInputElement).value;
    if (action != "create" && action != "edit") {
        return;
    }
    let deceasedId = +(document.getElementById("chronicleSelectedPerson") as HTMLElement).getAttribute("data-deceased-id");
    let memoryId = +(document.getElementById("editedMemoryId") as HTMLInputElement).value;
    let messageText = (document.getElementById("memoryText") as HTMLTextAreaElement).value.trim();
    if (messageText.length == 0)
        return;
    switch (action) {
        case "create":
            createNewMemory(deceasedId, messageText);
            break;
        case "edit":
            editMemory(memoryId, messageText, deceasedId);
            break;
    }
}

function createNewMemory(deceasedId: number, messageText: string) {
    fetch(CintorinConfig.baseUrl+"/api/chronicle/addMemory.php",  {
        method: "POST",
        headers: addAuthorization(new Headers({'Content-Type': 'application/json'})),
        body: JSON.stringify({
            deceasedId: deceasedId,
            message: messageText
        })
    }).then(response => {
        if (response.ok && response.status == 200) {
            return response.json();
        }
    }).then(result => {
        if (result && result.success) {
            (document.getElementById("memoryText") as HTMLTextAreaElement).value = "";
            (document.getElementById("editMemoryError") as HTMLElement).style.display = "none";
            dismissModal("#editMemoryModal");
            reloadMemories(deceasedId);
        } else {
            (document.getElementById("editMemoryError") as HTMLElement).style.display = "";
        }
    });
}

function editMemory(memoryId: number, messageText: string, deceasedId: number) {
    fetch(CintorinConfig.baseUrl+"/api/chronicle/editMemory.php",  {
        method: "POST",
        headers: addAuthorization(new Headers({'Content-Type': 'application/json'})),
        body: JSON.stringify({
            memoryId: memoryId,
            message: messageText
        })
    }).then(response => {
        if (response.ok && response.status == 200) {
            return response.json();
        }
    }).then(result => {
        if (result && result.success) {
            (document.getElementById("memoryText") as HTMLTextAreaElement).value = "";
            (document.getElementById("editMemoryError") as HTMLElement).style.display = "none";
            (document.getElementById("editedMemoryId") as HTMLInputElement).value = "";
            dismissModal("#editMemoryModal");
            reloadMemories(deceasedId);
        } else {
            (document.getElementById("editMemoryError") as HTMLElement).style.display = "";
        }
    });
}

function deleteMemory() {
    let memoryId = +this.parentElement.parentElement.parentElement.getAttribute("data-memory-id");
    let deceasedId = +(document.getElementById("chronicleSelectedPerson") as HTMLElement).getAttribute("data-deceased-id");
    if (memoryId && deceasedId) {
        fetch(CintorinConfig.baseUrl+"/api/chronicle/deleteMemory.php",  {
            method: "POST",
            headers: addAuthorization(new Headers({'Content-Type': 'application/json'})),
            body: JSON.stringify({ memoryId: memoryId })
        }).then(response => {
            if (response.ok && response.status == 200) {
                return response.json();
            }
        }).then(result => {
            if (result && result.success) {
                reloadMemories(deceasedId);
            } else {
                openModal("#genericErrorModal");
            }
        });
    }
}

function reportMemory() {
    let memoryId = +this.parentElement.parentElement.parentElement.getAttribute("data-memory-id");
    if (memoryId) {
        fetch(CintorinConfig.baseUrl+"/api/chronicle/reportMemory.php",  {
            method: "POST",
            headers: addAuthorization(new Headers({'Content-Type': 'application/x-www-form-urlencoded'})),
            body: "memoryId="+memoryId
        }).then(response => {
            if (response.ok && response.status == 200) {
                return response.json();
            }
        }).then(result => {
            if (result && result.success) {
                alert(getLocalizedText("messageReported"));
            } else {
                alert(getLocalizedText("messageReportError"));
            }
        });
    }
}

function reportCv() {
    let cvId = +document.getElementById("actualCv").getAttribute("data-cv-id");
    if (cvId) {
        fetch(CintorinConfig.baseUrl+"/api/chronicle/reportCv.php",  {
            method: "POST",
            headers: addAuthorization(new Headers({'Content-Type': 'application/x-www-form-urlencoded'})),
            body: "cvId="+cvId
        }).then(response => {
            if (response.ok && response.status == 200) {
                return response.json();
            }
        }).then(result => {
            if (result && result.success) {
                alert(getLocalizedText("messageReported"));
            } else {
                alert(getLocalizedText("messageReportError"));
            }
        });
    }
}

export function reloadMemories(deceasedId :number) {
    fetch(CintorinConfig.baseUrl+"/api/chronicle/htmlGetMemories.php?deceasedId="+deceasedId,  {
        method: "GET",
        headers: addAuthorization(new Headers({'Content-Type': 'application/urlencoded'}))
    }).then(response => {
        if (response.ok && response.status == 200) {
            return response.text();
        }
    }).then(resultHtml => {
        if (resultHtml) {
            document.getElementById("mementosContainer").innerHTML = resultHtml;
            toggleAuthorizedElementsVisibility("#mementosContainer");
            let memoryCount = document.querySelectorAll("#mementosContainer .memento").length;
            document.getElementById("numMemories").innerText = ""+memoryCount;
            if (memoryCount > 0) {
                document.querySelector("#chroniclePersonDropdown li[data-deceased-id='"+deceasedId+"'] .icon-memory")?.classList.add("icon-active");
                document.querySelector("#chronicleSelectedPerson[data-deceased-id='"+deceasedId+"'] .icon-memory")?.classList.add("icon-active");
            } else {
                document.querySelector("#chroniclePersonDropdown li[data-deceased-id='"+deceasedId+"'] .icon-memory")?.classList.remove("icon-active");
                document.querySelector("#chronicleSelectedPerson[data-deceased-id='"+deceasedId+"'] .icon-memory")?.classList.remove("icon-active");
            }
            attachMemoryActionsEventHandlers();
        }
    });
}

export function reloadCv() {
    let deceasedId = +(document.getElementById("chronicleSelectedPerson") as HTMLElement).getAttribute("data-deceased-id");
    if (!deceasedId) {
        return;
    }
    fetch(CintorinConfig.baseUrl+"/api/chronicle/htmlGetCv.php?deceasedId="+deceasedId,  {
        method: "GET",
        headers: addAuthorization(new Headers({'Content-Type': 'application/urlencoded'}))
    }).then(response => {
        if (response.ok && response.status == 200) {
            return response.text();
        }
    }).then(resultHtml => {
        if (resultHtml) {
            document.getElementById("kronika-cv-tab").innerHTML = resultHtml;
            attachCvEventHandlers();
            if (document.getElementById("actualCv")) {
                document.querySelector("#chroniclePersonDropdown li[data-deceased-id='"+deceasedId+"'] .icon-cv")?.classList.add("icon-active");
                document.querySelector("#chronicleSelectedPerson[data-deceased-id='"+deceasedId+"'] .icon-cv")?.classList.add("icon-active");
            } else {
                document.querySelector("#chroniclePersonDropdown li[data-deceased-id='"+deceasedId+"'] .icon-cv")?.classList.remove("icon-active");
                document.querySelector("#chronicleSelectedPerson[data-deceased-id='"+deceasedId+"'] .icon-cv")?.classList.remove("icon-active");
            }
        }
    });
}

function openNewCvForm() {
    document.getElementById("addCvButton").style.display = "none";
    document.getElementById("cvErrorMessage").style.display = "none";
    if (document.getElementById("cvPhotoContainer"))
        document.getElementById("cvPhotoContainer").style.display = "none";
    if (document.getElementById("addCvPhotosButton"))
        document.getElementById("addCvPhotosButton").style.display = "none";
    document.getElementById("editedCv").innerHTML = "";
    (document.getElementById("cvFormAction") as HTMLInputElement).value = "create";
    document.getElementById("cvForm").style.display = "";
}

function openEditCvForm() {
    document.getElementById("actualCv").style.display = "none";
    document.getElementById("cvActions").style.display = "none";
    document.getElementById("cvSignature").style.display = "none";
    document.getElementById("cvErrorMessage").style.display = "none";
    if (document.getElementById("cvPhotoContainer"))
        document.getElementById("cvPhotoContainer").style.display = "none";
    if (document.getElementById("addCvPhotosButton"))
        document.getElementById("addCvPhotosButton").style.display = "none";
    document.getElementById("editedCv").innerHTML = document.getElementById("actualCv").innerHTML;
    (document.getElementById("cvFormAction") as HTMLInputElement).value = "edit";
    document.getElementById("cvForm").style.display = "";
}

function filterPastedContent(e:ClipboardEvent) {
    e.preventDefault();
    let pastedContent = e.clipboardData.getData("text/plain");
    document.execCommand("insertText", true, pastedContent); // deprecated metoda ktora zatial nema nahradu v specke
}

function filterDroppedContent(e:DragEvent) {
    e.preventDefault();
    let droppedContent = e.dataTransfer.getData("text/plain");
    document.execCommand("insertText", true, droppedContent); // deprecated metoda ktora zatial nema nahradu v specke
}


function validateCvText() {
    document.getElementById("cvErrorMessage").style.display = "none";
    let cvText = document.getElementById("editedCv")?.innerText;
    (document.getElementById("cvSaveChangesButton") as HTMLButtonElement).disabled = (cvText.trim() == "");
}

function undoCvChanges() {
    let actionField = document.getElementById("cvFormAction") as HTMLInputElement;
    switch (actionField.value) {
        case "create":
            document.getElementById("editedCv").innerHTML = "";
            actionField.value = "";
            document.getElementById("cvForm").style.display = "none";
            document.getElementById("addCvButton").style.display = "";
        break;
        case "edit":
            document.getElementById("editedCv").innerHTML = "";
            actionField.value = "";
            document.getElementById("cvForm").style.display = "none";
            document.getElementById("actualCv").style.display = "";
            document.getElementById("cvActions").style.display = "";
            document.getElementById("cvSignature").style.display = "";
        break;
    }
    if (document.getElementById("cvPhotoContainer"))
        document.getElementById("cvPhotoContainer").style.display = "";
    if (document.getElementById("addCvPhotosButton"))
        document.getElementById("addCvPhotosButton").style.display = "";
}

function saveCvChanges() {
    let action = (document.getElementById("cvFormAction") as HTMLInputElement)?.value;
    let payload = document.getElementById("editedCv").innerHTML.trim();
    let deceasedId = +(document.getElementById("chronicleSelectedPerson") as HTMLElement).getAttribute("data-deceased-id");
    if (payload == "" || !deceasedId) {
        return;
    }
    switch (action) {
        case "create":
            createCv(deceasedId, payload);
            break;
        case "edit":
            let cvId = +document.getElementById("actualCv")?.getAttribute("data-cv-id");
            editCv(cvId, payload);
            break;
    }
}

function createCv(deceasedId: number, cvText: string) {
    (document.getElementById("cvSaveChangesButton") as HTMLButtonElement).disabled = true;
    fetch(CintorinConfig.baseUrl+"/api/chronicle/addCv.php", {
        method: "POST",
        headers: addAuthorization(new Headers({'Content-Type': 'application/urlencoded'})),
        body: JSON.stringify({
            deceasedId: deceasedId,
            cvText: cvText
        })
    }).then(response => {
        (document.getElementById("cvSaveChangesButton") as HTMLButtonElement).disabled = false;
        if (response.ok && response.status == 200) {
            return response.json();
        }
    }).then(result => {
        if (result && result.success) {
            reloadCv();
        } else {
            document.getElementById("cvErrorMessage").style.display = "";
        }
    });
}

function editCv(cvId:number, cvText:string) {
    fetch(CintorinConfig.baseUrl+"/api/chronicle/editCv.php", {
        method: "POST",
        headers: addAuthorization(new Headers({'Content-Type': 'application/urlencoded'})),
        body: JSON.stringify({
            cvId: cvId,
            cvText: cvText
        })
    }).then(response => {
        if (response.ok && response.status == 200) {
            reloadCv();
        } else {
            document.getElementById("cvErrorMessage").style.display = "";
        }
    })
}

function deleteCv() {
    let cvId = +document.getElementById("actualCv").getAttribute("data-cv-id");
    if (cvId) {
        fetch(CintorinConfig.baseUrl+"/api/chronicle/deleteCv.php",  {
            method: "POST",
            headers: addAuthorization(new Headers({'Content-Type': 'application/json'})),
            body: JSON.stringify({ cvId: cvId })
        }).then(response => {
            if (response.ok && response.status == 200) {
                return response.json();
            }
        }).then(result => {
            if (result && result.success) {
                reloadCv();
            } else {
                openModal("#genericErrorModal");
            }
        });
    }
}